import { useState, useCallback } from 'react';

const COMPLETED_KEY = 'ai_lab_completed_segments';
const VISITED_KEY = 'ai_lab_visited_segments';
const TOTAL = 9;

const readStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]');
  } catch {
    return [];
  }
};

export const useProgress = () => {
  const [completed, setCompleted] = useState(() => readStorage(COMPLETED_KEY));
  const [visited, setVisited] = useState(() => readStorage(VISITED_KEY));

  const markComplete = useCallback((segmentId) => {
    const current = readStorage(COMPLETED_KEY);
    if (!current.includes(segmentId)) {
      const updated = [...current, segmentId];
      localStorage.setItem(COMPLETED_KEY, JSON.stringify(updated));
      setCompleted(updated);
    }
  }, []);

  const markIncomplete = useCallback((segmentId) => {
    const current = readStorage(COMPLETED_KEY);
    const updated = current.filter((id) => id !== segmentId);
    localStorage.setItem(COMPLETED_KEY, JSON.stringify(updated));
    setCompleted(updated);
  }, []);

  const markVisited = useCallback((segmentId) => {
    const current = readStorage(VISITED_KEY);
    if (!current.includes(segmentId)) {
      const updated = [...current, segmentId];
      localStorage.setItem(VISITED_KEY, JSON.stringify(updated));
      setVisited(updated);
    }
  }, []);

  const isCompleted = useCallback((segmentId) => completed.includes(segmentId), [completed]);
  const isVisited = useCallback((segmentId) => visited.includes(segmentId), [visited]);

  const completedCount = completed.length;
  const progress = Math.round((completedCount / TOTAL) * 100);
  const nextSegment =
    Array.from({ length: TOTAL }, (_, i) => i + 1).find((id) => !completed.includes(id)) || 1;

  return {
    completed,
    completedCount,
    progress,
    markComplete,
    markIncomplete,
    markVisited,
    isCompleted,
    isVisited,
    nextSegment,
  };
};
